"use client"

import { createRootRoute, Outlet, useLocation } from "@tanstack/react-router";

import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/contexts/auth-context";
import ReloadPrompt from "@/components/reload-prompt";
import HelpModal from "@/components/help-modal";
import CameraModal from "@/components/camera-modal";

import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { getBookings } from "@/store/slices/bookingsSlice";
import { getHSDocuments } from "@/store/actions";
import ActivityIndicator from "@/components/ui/activity-indicator";


function RootComponent() {
    const location = useLocation();

    const dispatch = useDispatch();
    const isOnline = useSelector((state: any) => state.offline.online);
    const isLoadingBookings = useSelector((state: any) => state.bookings.loading);
    
    // Auth pages that don't need sidebar
    const authPages = ['/login', '/register', '/forgot-password', '/reset-password'];
    const isAuthPage = authPages.includes(location.pathname);

    if (isAuthPage) {
        return (
            <>
                <Outlet />
                <Toaster />
                <ReloadPrompt />
            </>
        );
    }

    // Init data loading
    useEffect(() => {
    if (isOnline) {
        dispatch(getBookings({ page: 0 }));
        dispatch(getHSDocuments());
    }
    }, [isOnline, dispatch]);

    return (
        <>
            <Outlet />
            <Toaster />
            <ReloadPrompt />
            <HelpModal />
            <CameraModal />
            {isLoadingBookings && (
                <div className="fixed inset-0 z-50 bg-black/40 flex items-center justify-center">
                    <ActivityIndicator size="lg" />
                </div>
            )}
        </>
    );
}

export const Route = createRootRoute({
    component: () => {
        return (
            <AuthProvider>
                <RootComponent />
            </AuthProvider>
        );
    },
    notFoundComponent: () => <div>404 Not Found</div>,
});
